import { FopiFundShareClassRequestDto } from '@asset-metrix/portal-gateway-client-js';
import { useQuery } from '@tanstack/react-query';

import { fetchFopiFundShareClassesData } from '../../api/portalGateway/fopiData';

export const useFundShareClassTableDataQuery = ({
  selection,
  enabled,
}: FopiFundShareClassRequestDto & {
  enabled: boolean;
}) =>
  useQuery({
    queryKey: ['fopi_shareClasses', { selection }],
    queryFn: fetchFopiFundShareClassesData,
    enabled,
  });
